// src/hooks/useOrgVoice.js
//
// The org's voice in one hook:
//   isCorporate — from the live (or previewed) organization
//   t(key)      — a copyDictionary entry for this audience
//   adapt(text) — phrase-level sport->corporate adaptation (adaptText.js)
//   voice(text) — inline {sport|corporate} tokens (worksheet content)

import { useMemo } from 'react';
import { useOrganization } from '../context/OrganizationContext';
import { copyFor, isCorporateOrg } from '../data/copyDictionary';
import { adaptCorporateText } from '../utils/adaptText';
import { voiceText } from '../utils/worksheetVoice';

export const useOrgVoice = () => {
    const { orgData } = useOrganization();
    const isCorporate = isCorporateOrg(orgData);
    return useMemo(() => ({
        isCorporate,
        t: (key) => copyFor(key, isCorporate),
        adapt: (text) => adaptCorporateText(text, isCorporate),
        voice: (text) => voiceText(text, isCorporate)
    }), [isCorporate]);
};

export default useOrgVoice;
